import { PetWorkflowStatuses } from 'shared/interfaces';
import {
  ListingWorkflowStatusId,
  PetWorkflowStatusAcronym,
  PetWorkflowStatusId,
  PetWorkflowStatusLabel,
  PetWorkflowStatusSlug,
} from 'utils/const';

/**
 * PET Workflow Statuses config settings
 */
export const petWorkflowStatuses: PetWorkflowStatuses = {
  approve: {
    id: PetWorkflowStatusId.Approved,
    label: PetWorkflowStatusLabel.Approved,
    acronym: PetWorkflowStatusAcronym.Approved,
    slug: PetWorkflowStatusSlug.Approved,
    workflowStatusIds: [ListingWorkflowStatusId.Approved],
  },

  pendingReview: {
    id: PetWorkflowStatusId.PendingReview,
    label: PetWorkflowStatusLabel.PendingReview,
    acronym: PetWorkflowStatusAcronym.PendingReview,
    slug: PetWorkflowStatusSlug.PendingReview,
    workflowStatusIds: [
      ListingWorkflowStatusId.PendingWorkAcceptance,
      ListingWorkflowStatusId.Submitted,
    ],
  },

  forwarded: {
    id: PetWorkflowStatusId.Forwarded,
    label: PetWorkflowStatusLabel.Forwarded,
    acronym: PetWorkflowStatusAcronym.Forwarded,
    slug: PetWorkflowStatusSlug.Forwarded,
    workflowStatusIds: [ListingWorkflowStatusId.Forwarded],
  },

  inProgress: {
    id: PetWorkflowStatusId.InProgress,
    label: PetWorkflowStatusLabel.InProgress,
    acronym: PetWorkflowStatusAcronym.InProgress,
    slug: PetWorkflowStatusSlug.InProgress,
    workflowStatusIds: [
      ListingWorkflowStatusId.ApprovalInProgress,
      ListingWorkflowStatusId.ForwardReviewInProgress,
    ],
  },

  pendingBreeder: {
    id: PetWorkflowStatusId.PendingBreeder,
    label: PetWorkflowStatusLabel.PendingBreeder,
    acronym: PetWorkflowStatusAcronym.PendingBreeder,
    slug: PetWorkflowStatusSlug.PendingBreeder,
    workflowStatusIds: [ListingWorkflowStatusId.Postponed],
  },

  notDefined: {
    id: PetWorkflowStatusId.NotDefined,
    label: PetWorkflowStatusLabel.NotDefined,
    acronym: PetWorkflowStatusAcronym.NotDefined,
    slug: PetWorkflowStatusSlug.NotDefined,
    workflowStatusIds: [],
  },
};
